// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_exceptions from "../../../../../rescript/lib/es6/caml_exceptions.js";

var SupportedLanguages_fromString_Not_found = /* @__PURE__ */Caml_exceptions.create("Languages-Catalyst.SupportedLanguages_fromString_Not_found");

function fromCode(language) {
  switch (language) {
    case "bn" :
        return /* Bangla */7;
    case "en" :
        return /* English */0;
    case "hi" :
        return /* Hindi */1;
    case "kn" :
        return /* Kannada */2;
    case "ml" :
        return /* Malayalam */6;
    case "mr" :
        return /* Marathi */5;
    case "ta" :
        return /* Tamil */3;
    case "te" :
        return /* Telugu */4;
    default:
      throw {
            RE_EXN_ID: SupportedLanguages_fromString_Not_found,
            Error: new Error()
          };
  }
}

function toLanguageString(lang) {
  switch (lang) {
    case /* English */0 :
        return "English";
    case /* Hindi */1 :
        return "हिन्दी";
    case /* Kannada */2 :
        return "ಕನ್ನಡ";
    case /* Tamil */3 :
        return "தமிழ்";
    case /* Telugu */4 :
        return "తెలుగు";
    case /* Marathi */5 :
        return "मराठी";
    case /* Malayalam */6 :
        return "മലയാളം";
    case /* Bangla */7 :
        return "বাংলা";
    
  }
}

function toLanguageCode(lang) {
  switch (lang) {
    case /* English */0 :
        return "en";
    case /* Hindi */1 :
        return "hi";
    case /* Kannada */2 :
        return "kn";
    case /* Tamil */3 :
        return "ta";
    case /* Telugu */4 :
        return "te";
    case /* Marathi */5 :
        return "mr";
    case /* Malayalam */6 :
        return "ml";
    case /* Bangla */7 :
        return "bn";
    
  }
}

export {
  SupportedLanguages_fromString_Not_found ,
  fromCode ,
  toLanguageString ,
  toLanguageCode ,
  
}
/* No side effect */
